import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { deleteDraft, clearDrafts } from '../../../redux/features/drafts/draftSlice'
import { Box, Divider, Flex, Grid, Image, Text } from '@chakra-ui/react'
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, Button } from '@chakra-ui/react'

const DraftsList = ({ isOpen, onClose, onSelectDraft }) => {
  const dispatch = useDispatch()
  const drafts = useSelector((state) => state.drafts.drafts)

  const handleClear = () => {
    dispatch(clearDrafts())
  }

  const handleDeleteDraft = (title) => {
    dispatch(deleteDraft(title))
  }

  return (
    <>
      <Modal isOpen={isOpen} onClose={handleClear} size="5xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Lista de rascunhos</ModalHeader>
          <ModalBody>
            {drafts.length === 0 && <Box>Nenhum rascunho salvo</Box>}
            <Grid templateColumns="repeat(auto-fill, minmax(300px, 1fr))" gap="4" w="full" maxW="1000px" mx="auto">
              {drafts.map((draft) => (
                <Box my="2" key={draft.id} border="1px solid" borderColor="gray.200" p="2">
                  <Flex gap={2}>
                    Título: <Box fontWeight="bold">{draft.title}</Box>
                  </Flex>
                  <Flex gap={2}>
                    Logo: <Image src={draft.image} alt={draft.title} />
                  </Flex>
                  <Flex gap={2}>
                    Tempo de leitura: <Box fontWeight="bold">{draft.timeToRead}</Box>
                  </Flex>
                  <Flex gap={2}>
                    Destaque: <Box fontWeight="bold">{draft.featured ? 'Sim' : 'Não'}</Box>
                  </Flex>

                  <Divider my="2" />
                  <Text>Conteúdo:</Text>
                  <Box p="2" dangerouslySetInnerHTML={{ __html: draft.content }} />

                  <Divider my="2" />
                  <Text>Ações:</Text>
                  <Button
                    colorScheme="blue"
                    onClick={() => {
                      onSelectDraft(draft)
                      onClose()
                    }}
                    size="sm"
                    alignSelf="flex-end"
                    mt="2"
                  >
                    Selecionar
                  </Button>

                  <Button
                    ml="2"
                    size="sm"
                    colorScheme="red"
                    onClick={() => {
                      handleDeleteDraft(draft.title)
                    }}
                    alignSelf="flex-end"
                    mt="2"
                  >
                    Deletar
                  </Button>
                </Box>
              ))}
            </Grid>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default DraftsList
